<script>
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Autoplay } from 'swiper'

import 'swiper/swiper-bundle.css'

SwiperCore.use([Autoplay])

export default {
	components: {
		Swiper,
		SwiperSlide
	},
  data() {
    return {
      activeSlide: 0,
      autoSlide: null,
    }
  },
  computed: {
    features(){
      return this.siteData?.features || []
    },
    sliderContent(){
      return this.siteData?.slider_content || ''
    },
    featureTitle(){
      return this.siteData?.feature_title ?? ''
    },
    featureSubtitle(){
      return this.siteData?.feature_subtitle ?? ''
    },
    companies() {
      return this.siteData?.companies || []
    },
  },
}
</script>

<template>
  <div>
    <section id="hero">
      <v-card
        color="transparent"
        dark
        flat
        tile
        height="768"
        class="slider-card overflow-hidden"
      >
        <video autoplay muted loop>
          <source src="/assets/slider-hero.mp4" type="video/mp4">
        </video>
        <div class="content">
          <div v-html="sliderContent"></div>
        </div>
      </v-card>
      <v-card
        color="white"
        dark
        flat
        tile
        height="120"
        elevation="3"
        class="d-flex align-center companies overflow-hidden"
				v-if="companies.length"
      >
        <v-container :fluid="isMiniPc">
					<swiper
						:slides-per-view="$vuetify.breakpoint.smAndDown ? 3 : 6"
						:space-between="30"
						:loop="true"
						style="height: 80px;"
						:autoplay="{ delay: 3000 }"
					>
						<swiper-slide
							v-for="company in companies"
							:key="`company-${company.id}`"
							class="d-flex align-center justify-center fill-height"
						>
							<v-img :src="company.image" max-height="80" max-width="80" position="center" />
						</swiper-slide>
					</swiper>
        </v-container>
      </v-card>
    </section>
    <section id="features" v-if="features">
      <v-container :fluid="isMiniPc" id="features" class="py-10">
				<template v-if="featureTitle || featureSubtitle">
					<div class="font-weight-light display-2" v-if="featureTitle" v-html="featureTitle" />
					<div class="feature-info" v-if="featureSubtitle" v-html="featureSubtitle" />
				</template>
				<div class="mb-10"></div>
				<div class="feature-list-container">
        	<v-row align="start" justify="space-around">
          <v-col
            cols="12"
            sm="4"
            v-for="(feature, i) in features"
            :key="i"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                class="card feature-card"
                flat
                color="transparent"
              >
                <div class="d-flex align-start">
                  <v-img
                    :src="feature.image"
                    :class="{ 'zoom-efect': hover }"
                    position="center center"
                    contain
                    width="100px"
                  />
                  <div>
                    <div class="font-weight-regular subtitle-1" v-html="feature.content"></div>
                  </div>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
				</div>
      </v-container>
    </section>
  </div>
</template>

<style lang="scss">
.slider-card {
  position: relative;
	max-width: 100%;
	overflow: hidden !important;
	video {
		max-width: 100%;
	}
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 70%;
    height: 200%;
    transform: rotate(30deg) translate(0,-50%);
    transform-origin: top left;
    background-color: rgba(255,255,255,.6);
    display: block;
    content: "";
  }
  .content {
    position: absolute;
    inset: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .actions {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
}
@media screen and (max-width: 600px) {
	.slider-card {
		height: auto !important;
		aspect-ratio: 16/9;
		.content {
			display: none;
		}
	}
	#features {
		max-width: 100vw;
		overflow: hidden !important;
	}
	.feature-info {
		overflow: hidden !important;
		max-width: 100% !important;
		font-size: 14px !important;
	}
	.feature-card {
		.d-flex {
			flex-direction: column;
			justify-content: center !important;
			align-items: center !important;
			text-align: center !important;
		}
	}
}
</style>
